import type { Calculation } from "~/tools/calculate-value-from-points";
import { ImmutableSet } from "~/tools/immutable-set";

const ALL_POSITIONS = ["bottom", "right"] as const;

type Position = (typeof ALL_POSITIONS)[number];

const ALL_MODES = ["list", "table"] as const;

type Mode = (typeof ALL_MODES)[number];

type Columns = ImmutableSet<Calculation>;

interface Settings {
	show?: boolean;
	position?: Position;
	mode?: Mode;
	columns?: Columns;
}

const DEFAULT = {
	show: true,
	position: "bottom",
	mode: "list",
	columns: ImmutableSet.empty,
} satisfies Settings;

export { ALL_POSITIONS, ALL_MODES, DEFAULT };
export type { Position, Mode, Columns, Settings };
